export const CLOSED_HEADER_BANNERS_COOKIE_NAME = 'closedHeaderBanners';
